'use client';

import { FeatherEye, FeatherFileText } from '@subframe/core';

interface TemplateRadioCardProps {
  title: string;
  originLabel: string;
  originHighlighted?: boolean;
  selected: boolean;
  onSelect: () => void;
  onPreview?: () => void;
}

export function TemplateRadioCard({
  title,
  originLabel,
  originHighlighted = false,
  selected,
  onSelect,
  onPreview,
}: TemplateRadioCardProps) {
  const handlePreview = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onPreview?.();
  };

  return (
    <div
      role="radio"
      aria-checked={selected}
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onSelect();
        }
      }}
      className={[
        'flex cursor-pointer items-center gap-3.5 rounded-[12px] border p-3.5 transition-all',
        selected
          ? 'border-brand-700 bg-brand-50 border-2 shadow-[0_0_0_3px_rgba(42,27,99,0.07)]'
          : 'bg-default-background border border-solid border-neutral-200 hover:border-neutral-300',
      ].join(' ')}
    >
      <div
        className={[
          'flex h-9 w-9 flex-none items-center justify-center rounded-[10px] transition-colors',
          selected ? 'bg-brand-100 text-brand-700' : 'text-subtext-color bg-neutral-100',
        ].join(' ')}
      >
        <FeatherFileText className="h-4 w-4" />
      </div>

      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <span className="text-body-bold font-body-bold truncate text-neutral-900">{title}</span>
        <span
          className={[
            'inline-flex h-[18px] w-fit items-center rounded-full px-2 text-[10px] font-bold tracking-wide',
            originHighlighted ? 'bg-brand-100 text-brand-700' : 'bg-neutral-100 text-neutral-700',
          ].join(' ')}
        >
          {originLabel}
        </span>
      </div>

      {onPreview && (
        <button
          type="button"
          onClick={handlePreview}
          className="bg-default-background text-caption font-caption text-subtext-color hover:border-brand-700 hover:text-brand-700 flex flex-none items-center gap-1.5 rounded-[8px] border border-solid border-neutral-200 px-2.5 py-1.5 transition-colors"
        >
          <FeatherEye className="h-3 w-3" />
          Visualizar
        </button>
      )}

      <div
        aria-hidden
        className={[
          'bg-default-background h-5 w-5 flex-none rounded-full transition-all',
          selected ? 'border-brand-700 border-[6px]' : 'border-2 border-neutral-300',
        ].join(' ')}
      />
    </div>
  );
}
